import React from 'react';
import { Table } from 'reactstrap';
import LoadMore from "../../../../components/common/LoadMore";
import './index.scss';
import NoRecord from "../../../../components/common/NoRecord";
import Moment from 'moment';
const PacketListing = ({ records, paginations, page, loading, _handlePageChange, label }) => {
	return (
		<div className="packet-listing">
			<Table borderless hover responsive>
				<thead>
					<tr>
						<th>DATE</th>
						<th className='text-center'>PACKETS</th>
						<th className='text-center'>TOTAL FILES</th>
						<th className='text-center'>AVG. COMPUTE TIME</th>
						<th>PROCESSED</th>
					</tr>
				</thead>
				<tbody>
					{
						records?.docs?.map((elem, i) => {
							return <tr key={i}>
								<th>{elem?._id && Moment(elem?._id).format('MMMM DD, YYYY')}</th>
								<td className='text-center'>{elem?.numberOfPackets}</td>
								<td className='text-center'>{elem?.numberOfFiles}</td>
								<td className='text-center'>{elem?.averageComputeTime ? Math.abs(elem?.averageComputeTime / 1000).toFixed(2) + 's' : ''}</td>
								<td>
									{  elem?.numberOfProcessPackets}
									{/*<span className={`value ${elem.icon ? 'text-danger' : 'text-success'}`}>
										<span className={`icon  d-inline-flex ${elem.icon ? 'down ' : 'up'}`}>
											<svg xmlns="http://www.w3.org/2000/svg" width="8.22" height="12.807" viewBox="0 0 8.22 12.807">
												<path id="up-arrow" d="M115.72,10.7l-4.11,4.11L107.5,10.7l.867-.867L111,12.468V2h1.226V12.453l2.623-2.623Z" transform="translate(-107.5 -2)" />
											</svg>
										</span>
										{elem.percent}
						              </span>*/}
								</td>
							</tr>
						}
						)
					}

					{records?.docs?.length === 0 && <tr>
						<td colSpan={5}>
							<NoRecord className='table-list' />
						</td>
					</tr>}
				</tbody>
			</Table>
			{(records?.totalDocs > paginations * page) && <LoadMore label={label} loading={loading} page={page} __handlePageChange={(activePage) => _handlePageChange(activePage)} />}
		</div>
	);
}

export default PacketListing;